import React, { useState, useContext } from 'react';
import PropTypes from "prop-types";

export const SelectedProductContext = React.createContext();

export const DrumallProductProvider = props => {
    const [state, setState] = useState({
        requestedProduct: window.drupalSettings && window.drupalSettings.requestedProduct,
        alternateProduct: window.drupalSettings && window.drupalSettings.alternateProduct
    });
    return (
        <SelectedProductContext.Provider
            value={{
                products: state,
                setProducts :setState,
            }}
        >
            {props.children}
        </SelectedProductContext.Provider>
    );
};

DrumallProductProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
};

export const useSelectedProducts = () => useContext(SelectedProductContext);
